var cell_phone = {};
module['exports'] = cell_phone;
cell_phone.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_IE/cell_phone/index.js
 ** module id = 418
 ** module chunks = 0
 **/